
import Effect from "../Effect";
class Compressor extends Effect {

	constructor(path, number) {
		super("Compressor", Compressor.nice_name, path, number);

		this.createParameter("threshold", {name: "threshold", min: -100, max: 0, step: 1, default: -24});

		this.createParameter("knee", {name: "knee", min: 0, max: 40, step: 0.2, default: 30});
		this.createParameter("ratio", {name: "ratio", min: 1, max: 20, step: 0.2, default: 12});
		this.createParameter("attack", {name: "attack", min: 0, max: 1, step: 0.2, default: 0.003});
		this.createParameter("release", {name: "release", min: 0, max: 1, step: 0.2, default: 0.25});
	}

	createNodes(context) {

		this.compressor = context.createDynamicsCompressor();

		this.getParameterByName('threshold').setParam(this.compressor.threshold);
		this.getParameterByName('knee').setParam(this.compressor.knee);
		this.getParameterByName('ratio').setParam(this.compressor.ratio);
		this.getParameterByName('attack').setParam(this.compressor.attack);
		this.getParameterByName('release').setParam(this.compressor.release);

		return {
			connect: (node) => {
				this.compressor.connect(node);
			},
			disconnect: (node) => {
				this.compressor.disconnect(node);
			},
			input: this.compressor
		};
	}
}

Compressor.nice_name = "Compressor";

export default Compressor;
